import { Portal } from '@mui/material';
import { PropsWithChildren, ReactElement } from 'react';

export const HEAD_PORTAL_ID = '__head-portal';

export function HeadPortal({ children }: PropsWithChildren): ReactElement {
  return <Portal container={document.querySelector(`#${HEAD_PORTAL_ID}`)}>{children}</Portal>;
}
